const PAYOUT_METHODS = Object.freeze({
  PAYPAL: 'PAYPAL',
  VENMO: 'VENMO',
  WITHOUT_PAYOUT_METHOD: 'WITHOUT_PAYOUT_METHOD'
})

export default PAYOUT_METHODS



// WEBPACK FOOTER //
// ./src/constants/claims/payoutMethods.js